import { LightShowOperation } from './lightshow-operation';
import { FlashTypes } from '../operation-types';
import { LightshowState } from '../lightshow-state';
import { LightshowTorchInstructionsComponent } from '../lightshow-torch-instructions/lightshow-torch-instructions.component';

const TIME_DECREMENT_STEP = 60;
const TIME_LOWER_BOUNDARY = 100;

export class SparkleOperation extends LightShowOperation {
    private time: number;
    private canChangeSwitchTime = true;
    private flareUp = false;
    private brightnessIncreaseRate = 0.1;
    private ignoreOverlap: boolean;
    private sparkleType: FlashTypes;
    private operationBrightness = 0;

    constructor(sparkleType: FlashTypes, position: number, duration: number, sectionList: string[], ignoreOverlap = false, uniqueId = Math.random().toString(36).slice(-5)) {
        super();
        this.position = position;
        this.duration = duration;
        this.color = 'white';
        this.flashType = FlashTypes.sparkleSteady;
        this.timelineColor = 'gold';
        this.uniqueId = uniqueId;
        this.ignoreOverlap = ignoreOverlap;
        this.sparkleType = sparkleType;
        this.sectionList = sectionList;
        this.operationFlashOn = false;
        this.show = true;
    }

    public toJson() {
      return [
        { type: this.sparkleType,
          duration: Math.round(this.duration) / 1000,
          intensity: 0.2,
          time: Math.round(this.position),
          sectionList: this.sectionList && this.sectionList.length > 0 ? this.sectionList : null
        }
      ];
    }

    public tick(state: LightshowState) {
        if (this.canChangeSwitchTime) {
          this.time = Math.floor(800 + Math.random() * 2000);
          this.canChangeSwitchTime = false;
          this.flareUp = true;
          state.isFlashOn = true;
          this.operationFlashOn = true;
          state.brightness = 0;
          this.operationBrightness = 0;
          this.brightnessIncreaseRate = Math.floor(15 + Math.random() * 30) / 100 ;
        }

        if (this.flareUp) {
          state.isFlashOn = true;
          this.operationFlashOn = true;
          state.brightness = Number(Math.min(1, state.brightness + this.brightnessIncreaseRate).toFixed(2));
          this.operationBrightness = Number(Math.min(1, this.operationBrightness + this.brightnessIncreaseRate * Math.random()).toFixed(2));
          this.flareUp =  state.brightness !== 1 || this.operationBrightness !== 1;
        } else if (!this.flareUp) {
          state.brightness = Number(Math.max(0, state.brightness - this.brightnessIncreaseRate).toFixed(2));
          state.isFlashOn = state.brightness !== 0;
          this.operationBrightness = Number(Math.max(0, this.operationBrightness - this.brightnessIncreaseRate).toFixed(2));
        }

        if (this.time < TIME_LOWER_BOUNDARY && state.brightness === 0) {
          this.canChangeSwitchTime = true;
          state.isFlashOn = false;
        } else if (this.time < TIME_LOWER_BOUNDARY && this.operationBrightness === 0) {
          this.canChangeSwitchTime = true;
        }

        this.time -=  TIME_DECREMENT_STEP;
    }

    public end(state: LightshowState) {
      state.isFlashOn = false;
      this.operationFlashOn = false;
    }

    public wait() { }
}
